export var FETCH_COMBOBET_TOKEN = 'FETCH_COMBOBET_TOKEN';
export var SUCCESS_FETCH_COMBOBET_TOKEN = 'SUCCESS_FETCH_COMBOBET_TOKEN';
export var FAILURE_FETCH_COMBOBET_TOKEN = 'FAILURE_FETCH_COMBOBET_TOKEN';



// WEBPACK FOOTER //
// ./src/actions/combobet/index.js